import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("shown.bs.collapse", this.scrollToTop.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.collapse", this.scrollToTop.bind(this))
  }

  scrollToTop() {
    const sidebar = document.getElementById("sidebar")
    if (sidebar) {
      sidebar.scrollTo({ top: 0, behavior: "smooth" })
    }
  }
}
